<div class="dialog-container">
  <h2 mat-dialog-title>Bulk Update Players</h2>

  <mat-dialog-content>
    <form [formGroup]="bulkUpdateForm" class="bulk-update-form">
      <div class="form-section">
        <p class="warning-message">
          This will update ALL players matching the current filters with the values below.
        </p>

        <mat-form-field appearance="outline">
          <mat-label>Quality</mat-label>
          <mat-select formControlName="quality">
            @for (option of qualityOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
          @if (bulkUpdateForm.get('quality')?.invalid && bulkUpdateForm.get('quality')?.touched) {
            <mat-error>Quality is required</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Rarity ID</mat-label>
          <input
            matInput
            formControlName="rarity_id"
            type="number"
            placeholder="Enter rarity ID"
          />
          @if (bulkUpdateForm.get('rarity_id')?.invalid && bulkUpdateForm.get('rarity_id')?.touched) {
            <mat-error>Rarity ID is required and must be at least 0</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Overall Rating</mat-label>
          <input
            matInput
            formControlName="overall"
            type="number"
            min="0"
            max="99"
            placeholder="Enter overall rating (0-99)"
          />
          @if (bulkUpdateForm.get('overall')?.invalid && bulkUpdateForm.get('overall')?.touched) {
            <mat-error>Overall must be between 0 and 99</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Market Price</mat-label>
          <input
            matInput
            formControlName="market_price"
            type="number"
            min="0"
            placeholder="Enter market price"
          />
          @if (bulkUpdateForm.get('market_price')?.invalid && bulkUpdateForm.get('market_price')?.touched) {
            <mat-error>Market price is required and must be at least 0</mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="loading">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="loading || bulkUpdateForm.invalid"
    >
      @if (loading) {
        <mat-spinner [diameter]="20"></mat-spinner>
      }
      @else {
        Update All
      }
    </button>
  </mat-dialog-actions>
</div>
